import { render, staticRenderFns } from "./PricePresenter.vue?vue&type=template&id=050cda92&lang=pug&"
import script from "./PricePresenter.vue?vue&type=script&lang=ts&"
export * from "./PricePresenter.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports